import styled from "@emotion/styled";
import { Link } from "atoms";
import { Thumbnail } from "features/images";
import type { Image } from "features/images";
import type { ReviewableAffiliation } from "../types";

interface AffiliatedCollectionProps {
  affiliations: ReviewableAffiliation[];
}

function AffiliatedCollections({ affiliations }: AffiliatedCollectionProps) {
  return (
    <SAffiliatedCollection role="list">
      {affiliations.map((affiliation) => (
        <li key={affiliation.id}>
          <AffiliatedCollection
            id={affiliation.id}
            name={affiliation.name || affiliation.id}
            image={affiliation.image}
          />
        </li>
      ))}
    </SAffiliatedCollection>
  );
}

const SAffiliatedCollection = styled.ul({
  display: "grid",
  fontWeight: "bold",
  gap: "2rem",
  gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
  lineHeight: 1.3,
  marginTop: "2rem",
  li: {
    "&::before": {
      position: "absolute",
    },
  },
  img: {
    width: 50,
    height: 50,
  },
});

function AffiliatedCollection({
  id,
  name,
  image,
}: {
  id: string;
  name: string;
  image: Image;
}) {
  return (
    <SLink to={`/projects/${id}`}>
      <Thumbnail src={image} alt="" small rounded />
      {name}
    </SLink>
  );
}

const SLink = styled(Link)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  fontSize: theme.fontSizes.xs,
  gap: "0.5rem",
  textDecoration: "none",
}));

export { AffiliatedCollections };
